import bridge from '@utiles/bridge';
import globalConfig from '@utiles/globalConfig';
import { getStoreUrlParams } from '@utiles/index';
/* 
  访问页面没有cid, 设置默认cid
  SDK内环境：cid=sdk
  SDK外环境：cid=web
*/
export const handleStoreDefaultCid = () => {
  if (
    globalConfig.getHrefParam('cid') ||
    window.globalIsSrtlUrlParams() ||
    window.location.hash === '#/result'
  ) {
    return;
  }

  // 兼容美国iOS游戏内按钮第三方支付访问中转页未带srtl参数：如果是【中转页+iOS+有btnId+当前SDK版本】，则强制添加srtl参数为3287.0.0.0
  const hashPath = window.location?.hash?.split('?')?.[0] || '';
  const isSelectPage =
    window.location.pathname === '/platform/store.html' &&
    hashPath === '#/select';
  const isIos = globalConfig.getHrefParam('devicePlate') === 'ios';
  const btnId = globalConfig.getHrefParam('btnId');
  const sdkVersion = globalConfig.getHrefParam('sdkVersion');
  const hasSrtl = globalConfig.getHrefParam('srtl');
  if (
    isSelectPage &&
    isIos &&
    btnId &&
    btnId !== '0' &&
    sdkVersion === 'v25.7.3' &&
    !hasSrtl
  ) {
    let urlParams = window.globalGetLinkParams();
    Object.assign(urlParams, { srtl: '3287.0.0.0' });
    let url = window.location.href;
    Object.keys(urlParams).forEach(key => {
      url = globalConfig.hrefAddParam(url, key, urlParams[key]);
    });
    window.location.href = url;
    return;
  }
  const newCid = bridge.runInsdk() ? 'sdk' : 'web';
  let url = globalConfig.hrefAddParam(window.location.href, 'cid', newCid);
  window.location.href = window.globalGetSdkLink({
    link: url,
    inSdk: bridge.runInsdk()
  });
};

export const updateObjScidAndCidOnStoreResult = data => {
  if (!data) return data;
  const storeUrlParams = getStoreUrlParams();
  try {
    data.cid = storeUrlParams?.cid || data?.cid || '';
    data.scid = storeUrlParams?.scid || data?.scid || '';
    return data;
  } catch (e) {
    console.error(e);
    return data;
  }
};
